import {
  GET_PRODUCT_DETAILS,
  GET_PRODUCTS_OVERVIEW,
  GET_SHIPPING_DETAILS,
  CREATE_LOYALTY_ORDER_BUNDLE,
  PAY_LOYALTY_ORDER_BUNDLE,
  GET_LOYALTY_ORDER_INFORMATION,
  DELETE_PENDING_LOYALTY_CREDIT
} from '@/utils/store/actionTypes'
import { LocaleIsoCodes } from '@/enums/general'
import getProductDetails from '@/apollo/webshop/products/getLoyaltyProductDetail.graphql'
import getLoyaltyProductOverviews from '@/apollo/webshop/products/getLoyaltyProductOverviews.graphql'
import getShippingDetails from '@/apollo/webshop/getShippingDetails.graphql'
import createLoyaltyOrderBundle from '@/apollo/webshop/createLoyaltyOrderBundle.graphql'
import getConfirmationLoyaltyOrderBundle from '@/apollo/webshop/getConfirmationLoyaltyOrderBundle.graphql'
import loyaltycheckout from '@/apollo/webshop/loyaltycheckout.graphql'
import { apolloClient } from '@/utils/store'

export default {
  async [GET_PRODUCT_DETAILS] ({ rootState }, { slug }) {
    const language = LocaleIsoCodes[rootState.app.locale]

    const { data } = await apolloClient(this).query({
      query: getProductDetails,
      variables: {
        language,
        slug
      }
    })

    return data.getLoyaltyProductDetail
  },
  async [GET_PRODUCTS_OVERVIEW] ({ rootState }) {
    const language = LocaleIsoCodes[rootState.app.locale]

    const { data } = await apolloClient(this).query({
      query: getLoyaltyProductOverviews,
      variables: {
        language
      }
    })

    return data.getLoyaltyProductOverviews
  },
  async [GET_SHIPPING_DETAILS] ({ rootState }) {
    const { data } = await apolloClient(this).query({
      query: getShippingDetails,
      variables: {
        country: rootState.app.country
      }
    })

    return data.getShipmentDetails
  },
  async [CREATE_LOYALTY_ORDER_BUNDLE] (_, {
    products = [],
    streetType = '',
    street = '',
    houseNumber = '',
    houseNumberAddition = '',
    phoneNumber = '',
    building = '',
    floor = '',
    postalCode = '',
    city = '',
    area = '',
    region = ''
  }) {
    const { data } = await apolloClient(this).mutate({
      mutation: createLoyaltyOrderBundle,
      variables: {
        products,
        streetType,
        street,
        houseNumber,
        houseNumberAddition,
        phoneNumber,
        building,
        floor,
        postalCode,
        city,
        area,
        region
      }
    })

    return data.createLoyaltyOrderBundle.loyaltyOrderBundle.orderBundleId
  },
  async [PAY_LOYALTY_ORDER_BUNDLE] ({ rootState }, {
    orderBundle = '',
    issuerId = null,
    paymentMethodNonce = null,
    paymentType = '',
    successUrl = '',
    failedUrl = '',
    pendingUrl = ''
  }) {
    const { data } = await apolloClient(this).mutate({
      mutation: loyaltycheckout,
      variables: {
        orderBundle,
        issuerId,
        paymentMethodNonce,
        paymentType,
        language: rootState.app.locale,
        successUrl,
        failedUrl,
        pendingUrl
      }
    })

    return data.createLoyaltyCheckout.loyaltyCheckout.redirectUrl
  },
  async [GET_LOYALTY_ORDER_INFORMATION] (_, { orderBundleId }) {
    try {
      const { data } = await apolloClient(this).query({
        query: getConfirmationLoyaltyOrderBundle,
        variables: {
          orderBundleId: parseInt(orderBundleId)
        }
      })

      return data.getConfirmationLoyaltyOrderBundle
    } catch (e) { }

    return null
  },
  async [DELETE_PENDING_LOYALTY_CREDIT] () {
    const response = await this.$axios.$delete(`${process.env.API_URL}/v2/loyalty/pending`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  }
}
